import { createSelector } from '@reduxjs/toolkit';

import { currentOpenChatSelector } from '../currentOpenChatSelector';

export const hintQuestionsIsVisibleSelector = createSelector(
  currentOpenChatSelector,
  openChat => openChat?.hintQuestions?.isVisible || false,
);
